import { Component, Inject, OnInit } from '@angular/core';
import { MatDialogRef, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { FormGroup, FormBuilder, Validators } from '@angular/forms';
import { LoginTipleri } from '@core/genel/AppEnums';
import { environment } from '@environments/environment';

@Component({
	selector: 'm-iptal-dialog',
	templateUrl: './iptal-dialog.component.html'
})
export class IptalDialogComponent implements OnInit {
	viewLoading: boolean = false;
	form: FormGroup;	
	loginTipi: number = environment.LOGIN_TIPI;
	enmLoginTipleri = LoginTipleri;
	constructor(private fb: FormBuilder,
		public dialogRef: MatDialogRef<IptalDialogComponent>,
		@Inject(MAT_DIALOG_DATA) public data: any
	) { }

	ngOnInit() {
		this.formHazirla();
	}

	formHazirla() {
		this.form = this.fb.group({
			MESAJ: [null, Validators.compose([Validators.required])]
		});
	}

	onNoClick(): void {
		this.dialogRef.close();
	}

	onYesClick(): void {
		/* Server loading imitation. Remove this */
		this.viewLoading = true;
		this.dialogRef.close(this.form); // Keep only this row
	}
}